import "./ts/slider";
import "./ts/slider-image";
import "./ts/accordion";
import "./ts/hamburger";
//import "./ts/bundle";
import "./ts/myAccount";
import "./ts/user";
import "./ts/cart";
import "./ts/checkout";
import "./ts/orderTypePopup";
import "./ts/mainProduct";
import "./ts/landing";
import "./ts/thankyou";
import "./ts/qr";
import "./ts/utm";
import "./ts/cookie";
import "./ts/clickEvents";
import "./main.css";
import "./ts/njamitoComponents";
import "./ts/counter";
import "./ts/heroMedia";

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({disable: 'mobile'});

import "./ts/gsapAnimations"
